export default __webpack_public_path__ + "static/media/1098.31860db0.png";